import {
  CREATE_SAFESCARF_USER_FULFILLED,
  FETCH_SAFESCARF_USERS_FULFILLED,
  UPDATE_SAFESCARF_USER_FULFILLED,
} from './actions';

import type { SafeScarfUser } from '@/types/safeScarf';


export interface SafeScarfUsersAction {
  type: string;
  payload?: SafeScarfUser | SafeScarfUser[];
}

const usersReducer = (state: SafeScarfUser[] = [], action: SafeScarfUsersAction): SafeScarfUser[] => {
  switch (action.type) {
    case CREATE_SAFESCARF_USER_FULFILLED:
      return [...state, action.payload as SafeScarfUser];
    case FETCH_SAFESCARF_USERS_FULFILLED:
      return action.payload as SafeScarfUser[];
    case UPDATE_SAFESCARF_USER_FULFILLED: {
      const updated = action.payload as SafeScarfUser;
      return state.map(user => {
        if (user.username === updated.username) {
          return { ...user, ...updated };
        }
        return user;
      });
    }
    default:
      return state;
  }
};

export { usersReducer };
